import { observable } from 'mobx'

/*
  showTips 是否显示通知提示框
  showNotice 是否显示提醒相关部分
  isShowInput 是否显示input输入框
  isShowLogo 是否显示主页导航logo
  showlogout 是否显示退出框
  isCanDetailVisible 右侧查看是否放大
  wasteQuantity 垃圾量
  canDetailDate 桶信息界面的時間（年月日）
  canDetailTime 桶信息界面的时间（具体时间）
  canDetailPercentage 桶信息界面当前选中的时间点的量
*/
class OverViewViewStore {
  @observable isShowInput = false
  @observable isShowLogo = true
  @observable showlogout = false
  @observable isCanDetailVisible = false
  @observable isCanInfoVisible = true
  @observable showEmptyCans = true
  @observable wasteQuantity = null
  @observable chartNeedUpdate = false
  @observable city = ''
  @observable temperature = 'N/N'
  @observable weatherCondition = 'N/N'
  @observable flag = false
  @observable hideInfoFlag = true
  @observable hideCansListFlag = true
  @observable showList = false
  @observable showAll = true
  @observable showRed = false
  @observable showYellow = false
  @observable showGreen = false
  @observable positive = false
  @observable reverse = true
  @observable showName = true //showName为true时首页按照name进行显示,为false时按照id显示
  @observable showSouSuo = false
  @observable souContent = ''
  @observable souList = []
  @observable showRoll = true
  @observable showTips = false
  @observable showNotice = true
  @observable NoticeCanNeedUpdate = false
  @observable audioItem = null
  @observable canDetailDate = ''
  @observable canDetailTime = ''
  @observable canDetailPercentage = '--'
}

const store = new OverViewViewStore()

export default store



// WEBPACK FOOTER //
// ./src/store/OverViewViewStore.js